import React from 'react';

import TaxonomyMaterialTypeDetail from './Detail';
import TaxonomyMaterialTypeTeaser from './Teaser';

const TaxonomyMaterialType = ({ entity, viewMode }) => {

  switch (viewMode) {
    case 'teaser':
      return <TaxonomyMaterialTypeTeaser entity={entity} />;
    case 'full':
    default:
      return <TaxonomyMaterialTypeDetail entity={entity} />;
  }
};

export default TaxonomyMaterialType;
